import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Overline, Reveal, MaskLine } from "./shared";
import { useLang } from "@/i18n";

const nums = ["01", "02", "03"];

export default function Manifesto() {
  const { t } = useLang();
  const chapters = t("manifesto.chapters");
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="story" className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32" data-testid="manifesto-section">
      <Overline>{t("manifesto.overline")}</Overline>
      <h2 className="mt-4 max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl lg:text-6xl">
        <MaskLine>{t("manifesto.title1")}</MaskLine>
        <MaskLine delay={0.12}>
          <span className="italic text-terracotta">{t("manifesto.title2")}</span>
        </MaskLine>
      </h2>

      <div className="mt-20 space-y-24 lg:space-y-32">
        {chapters.map((c, i) => (
          <div key={nums[i]} className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            <Reveal className={`lg:col-span-4 ${i % 2 === 1 ? "lg:order-2 lg:text-right" : ""}`}>
              <span className="font-serif text-7xl font-light leading-none text-ochre/70 lg:text-8xl">{nums[i]}</span>
            </Reveal>
            <Reveal delay={0.15} className={`lg:col-span-8 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <h3 className="font-serif text-2xl font-semibold tracking-tight sm:text-3xl">{c.title}</h3>
              <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-moss">{c.body}</p>
            </Reveal>
          </div>
        ))}
      </div>

      <Reveal className="mt-24 lg:mt-32">
        <div ref={imgRef} className="relative aspect-[16/7] overflow-hidden border border-ink/10">
          <motion.img
            src="/assets/farm/inauguration-ribbon.jpeg"
            alt="Inauguration of the Sira Shakti wood press oil processing unit"
            style={{ y, scale: 1.18 }}
            className="h-full w-full object-cover"
          />
          <p className="absolute bottom-4 left-4 bg-cream/90 px-4 py-2 text-xs uppercase tracking-[0.2em] text-ink backdrop-blur-sm">
            {t("manifesto.caption")}
          </p>
        </div>
      </Reveal>
    </section>
  );
}
